
<ng-container *ngIf="!isRouterUrlNewOrder() && showHeader">
  <navbar></navbar>
</ng-container>

<app-spinner-overlay></app-spinner-overlay>
<router-outlet></router-outlet>
<!-- app-footer ></app-footer -->
